import React, { useEffect, useState } from "react";
import wpHttp from "../../wpApi";
import s from "./index.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(s);

export const FooterCTABoxes = ({ doorType }) => {
    const [footerCTABoxesInfo, setFooterCTABoxesInfo] = useState(null);

    const loadFooterCTABoxes = async () => {
        try {
            const response = await wpHttp.get(
                `/wp-json/acf/v3/options/options/door_footer_cta`
            );
            if (
                response.data.door_footer_cta
            ) {
                setFooterCTABoxesInfo(response.data.door_footer_cta);
            } else {
                console.log("Can't reach Footer CTA Boxes");
            }
        } catch (error) {
            // do nothing the footer cta boxes just won't show
        }
    };
    useEffect(() => {
        loadFooterCTABoxes();
    }, []);

    return footerCTABoxesInfo ? (
        <React.Fragment>
            <div className={cx(s.footer_cta)}>
                <div className="container">
                    {footerCTABoxesInfo.section_heading ? (
                        <div className="row">
                            <div className="col col-12">
                                <h2 className="footer-cta--headline text-center">{footerCTABoxesInfo.section_heading}</h2>
                            </div>
                        </div>
                    ) : null}
                    <div className="row">
                        {footerCTABoxesInfo.footer_column_1.footer_column_image.url ? (
                            <div className={cx(s.col, "col col-12 col-sm-4")}>
                                <a className={s["footer-cta--image-link"]} 
                                    href={footerCTABoxesInfo.footer_column_1.footer_column_link.url} 
                                    target="" 
                                    alt={footerCTABoxesInfo.footer_column_1.footer_column_title}
                                >
                                    <img src={footerCTABoxesInfo.footer_column_1.footer_column_image.url} alt={footerCTABoxesInfo.footer_column_1.footer_column_image.alt}  />
                                    {footerCTABoxesInfo.footer_column_1.footer_column_title ? (
                                        <span className={s["footer-cta--heading"]}>
                                            <span className={cx(s.fa, s.fa_caret_right, "fa fa-caret-right")}></span>
                                            {footerCTABoxesInfo.footer_column_1.footer_column_title}
                                        </span>
                                     ) : null}
                                </a>
                            </div>
                        ) : null}
                        {footerCTABoxesInfo.footer_column_2.footer_column_image.url ? (
                            <div className={cx(s.col, "col col-12 col-sm-4")}>
                                <a className={s["footer-cta--image-link"]} 
                                    href={footerCTABoxesInfo.footer_column_2.footer_column_link.url} 
                                    target={footerCTABoxesInfo.footer_column_2.footer_column_link.target} 
                                    alt={footerCTABoxesInfo.footer_column_2.footer_column_title}>

                                    <img src={footerCTABoxesInfo.footer_column_2.footer_column_image.url} alt={footerCTABoxesInfo.footer_column_2.footer_column_image.alt} />

                                    {footerCTABoxesInfo.footer_column_2.footer_column_title ? (
                                        <span className={s["footer-cta--heading"]}>
                                            <span className={cx(s.fa, s.fa_caret_right, "fa fa-caret-right")}></span>
                                            {footerCTABoxesInfo.footer_column_2.footer_column_title}
                                        </span>
                                    ) : null}
                                </a>
                            </div>
                        ) : null}
                        {footerCTABoxesInfo.footer_column_3.footer_column_image.url ? (
                            <div className={cx(s.col, "col col-12 col-sm-4")}>
                                <a className={s["footer-cta--image-link"]}
                                    href={footerCTABoxesInfo.footer_column_3.footer_column_link.url} 
                                    target={footerCTABoxesInfo.footer_column_3.footer_column_link.target} 
                                    alt={footerCTABoxesInfo.footer_column_3.footer_column_title}>

                                <img src={footerCTABoxesInfo.footer_column_3.footer_column_image.url} alt={footerCTABoxesInfo.footer_column_3.footer_column_image.alt} />

                                {footerCTABoxesInfo.footer_column_3.footer_column_title ? (
                                    <span className={s["footer-cta--heading"]}>
                                        <span className={cx(s.fa, s.fa_caret_right, "fa fa-caret-right")}></span>
                                        {footerCTABoxesInfo.footer_column_3.footer_column_title}
                                    </span>
                                ) : null}
                                </a>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </React.Fragment>
    ) : null;
};
